import vars from './src/vars';

let env = vars.ENV;

const config = require(`./config/firebase-config-${env}`);

export default config.default;